var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sort-button",class:_vm.active ? 'sort-active' : '',attrs:{"title":_vm.tooltip},on:{"click":function($event){return _vm.doSort($event)}}},[_c('font-awesome-icon',{attrs:{"fixed-width":"","icon":_vm.arrow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }